// 二级品牌馆配置 幻城
export default {
  'metacity.ubanquan.cn': {
    // 主应用二级品牌馆id映射
    development: {
      storeNo: 'ST788800000100001669877051',
      storeName: '幻城',
      microHost: 'metacity-brand.ubanquan.cn'
    },
    test: {
      storeNo: 'ST788800000100001669877051',
      storeName: '幻城',
      microHost: 'metacity-brand.ubanquan.cn'
    },
    realpre: {
      storeNo: 'ST788800000100001669877051',
      storeName: '幻城',
      microHost: 'metacity-brand.ubanquan.cn'
    },
    production: {
      storeNo: 'ST788800000100001669877051',
      storeName: '幻城',
      microHost: 'metacity-brand.ubanquan.cn'
    }
  }
};